<div [formGroup]="fg">
  <mat-form-field>
    <textarea matInput formControlName="note"></textarea>
  </mat-form-field>
</div>
